import { create } from 'zustand'

const useAuditStore = create((set) => ({

    audit: [],

    tab: 'initial',

    patient: 0,

    showResults: false,

    reset: () => set(state => {

        return {...state, 
            audit: [], 
            tab: 'initial',
            patient: 0,
            showResults: false
        }
    }),

    setAudit: (audit) => set(state => {

        return {...state, audit}
    }),

    setTab: (tab) => set(state => {

        return {...state, tab}
    }),

    setPatient: (patient) => set(state => {

        return {...state, patient}
    }),

    toggleResults: () => set(state => {

        return {...state, showResults: !state.showResults}
    }),

    setup: (audit, tab) => set(state => {

        return {...state, audit, tab, patient: 0, showResults: false}
    }),

    updateRow: (row) => set(state => {

        let audit = JSON.parse(JSON.stringify(state.audit));

        const rowIndex = audit.findIndex(r => r.id === row.id);

        audit[rowIndex] = row;

        return {...state, audit}
    })

}))


export default useAuditStore;